// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2oChe","author":"Table_author__EnEJM","authorImage":"Table_authorImage__3t677","unreadRow":"Table_unreadRow__iUfsh"};